module.exports = __webpack_public_path__ + "img/17.abab83ac.svg";